import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { track } from "@/lib/fmt";

const Ctx = createContext(null);
export const useStore = () => useContext(Ctx);

const sessId = () => {
  let s = localStorage.getItem("na_sess");
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("na_sess", s);
  }
  return s;
};

function captureUtm() {
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ["source", "medium", "campaign", "content", "term"].forEach((k) => p.get(`utm_${k}`) && (utm[k] = p.get(`utm_${k}`)));
  if (Object.keys(utm).length) sessionStorage.setItem("na_utm", JSON.stringify(utm));
}
export const getUtm = () => JSON.parse(sessionStorage.getItem("na_utm") || "{}");

export function StoreProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [meta, setMeta] = useState({ needs: [], categories: [] });
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("na_cart") || "[]"));
  const [pricing, setPricing] = useState(null);
  const [drawer, setDrawer] = useState(false);
  const [quick, setQuick] = useState(null);

  useEffect(() => {
    captureUtm();
    api.get("/settings/public").then((r) => setSettings(r.data));
    api.get("/catalog/meta").then((r) => setMeta(r.data));
  }, []);

  useEffect(() => {
    localStorage.setItem("na_cart", JSON.stringify(items));
    if (!items.length) return setPricing(null);
    const t = setTimeout(() => api.post("/cart/price", { itens: items }).then((r) => setPricing(r.data)).catch(() => {}), 120);
    return () => clearTimeout(t);
  }, [items]);

  const add = useCallback((slug, frascos = 1, quantidade = 1, assinatura = false, open = "drawer", value) => {
    setItems((prev) => {
      const i = prev.findIndex((x) => x.slug === slug && x.frascos === frascos && !!x.assinatura === !!assinatura);
      if (i >= 0) return prev.map((x, k) => (k === i ? { ...x, quantidade: Math.min(20, x.quantidade + quantidade) } : x));
      return [...prev, { slug, frascos, quantidade, assinatura }];
    });
    track("add_to_cart", { item_id: slug, quantity: frascos * quantidade, value });
    if (open === "drawer") setDrawer(true);
    if (open === "quick") setQuick("sacola");
  }, []);
  const setQty = (idx, q) => setItems((p) => (q <= 0 ? p.filter((_, k) => k !== idx) : p.map((x, k) => (k === idx ? { ...x, quantidade: Math.min(20, q) } : x))));
  const remove = (idx) => setItems((p) => p.filter((_, k) => k !== idx));
  const count = items.reduce((a, b) => a + b.quantidade, 0);

  const value = useMemo(
    () => ({ settings, meta, items, setItems, pricing, add, setQty, remove, clear: () => setItems([]), count, drawer, setDrawer, quick, setQuick, sessao: sessId() }),
    [settings, meta, items, pricing, add, count, drawer, quick]
  );
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const needOf = (meta, p) => {
  const keys = (p?.necessidades || []).filter((k) => k !== "kits" && k !== "chas");
  const k = keys[0] || p?.necessidades?.[0];
  return meta.needs.find((n) => n.chave === k) || { nome: "", cor_fundo: "#ECF2EA", cor_texto: "#1E4D3A" };
};
